module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {}, [_c('banner-main', {
    attrs: {
      "arr": _vm.bannerHome
    }
  }), _vm._v(" "), _c('ui_title_line', {
    attrs: {
      "text_decoration": "underline"
    }
  }, [_vm._v("\n      НАЙТИ НАДЕЖНОГО АДВОКАТА ПРОСТО!\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "contact-block-wraper container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ui_auto', {
    attrs: {
      "height": "50",
      "dense": "",
      "filled": "",
      "solo": "",
      "rounded": "",
      "label": "Опишите свою проблему",
      "items": _vm.specializations
    },
    model: {
      value: (_vm.problem),
      callback: function($$v) {
        _vm.problem = $$v
      },
      expression: "problem"
    }
  }), _vm._v(" "), _c('ui_btn', {
    attrs: {
      "type": "main-btn",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.toSearch
    }
  }, [_vm._v("Найти адвоката")])], 1)]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      О СЕРВИСЕ\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-about-service container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-wraper-home"
  }, [_c('ui_text', [_c('p', [_vm._v("\n               Сервис \"Мобильный адвокат\" - это площадка, на которой любой пользователь может найти адвоката, отвечающего всем его требованиям, а адвокату найти новых клиентов.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "is-desctop"
  }, [_vm._v("\n              Отличительной особенностью сервиса является \"Безопасная Сделка\": оплачивая услуги адвоката через наш сервис, клиент может быть уверен, что его деньги в сохранности. Адвокат получает деньги только после выполнения всех договоренностей. В противном случае деньги возвращаются клиенту в полном объеме\n            ")])]), _vm._v(" "), _c('ui_text_href', {
    staticStyle: {
      "margin-top": "59px"
    },
    attrs: {
      "href": "/service"
    }
  }, [_vm._v("\n            Подробнее\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 counter-wrapper-home"
  }, [_c('adv-counter', {
    attrs: {
      "arr": _vm.countOne,
      "titile": "Зарегистрировано адвокатов"
    }
  }), _vm._v(" "), _c('adv-counter', {
    attrs: {
      "arr": _vm.countTwo,
      "titile": "Успешных сделок"
    }
  })], 1)])]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      СЕРВИС ОТМЕНЫ СУДЕБНОГО ПРИКАЗА\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-about-service container"
  }, [_c('div', {
    staticClass: "row for-mobile"
  }, [_c('div', {
    staticClass: "col-6 jus-center"
  }, [_c('div', {
    staticClass: "text-home-block"
  }, [_c('ui_text', [_vm._v("\n              Автоматическое оформление заявления об отмене судебного приказа и отправление его в суд. За 5 минут.\n            ")]), _vm._v(" "), _c('ui_text', [_c('p', {
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_vm._v("\n                Стоимость услуги составит: "), _c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("1500 р.")])])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "67px",
      "z-index": "2"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/cancel"
    }
  }, [_c('ui_btn', {
    attrs: {
      "type": "main-btn"
    }
  }, [_vm._v("Отменить судебный приказ")])], 1)], 1)]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      БЕЗОПАСНАЯ СДЕЛКА\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.adv.length > 3) ? _c('ui_title_line', [_vm._v("\n      ПОПУЛЯРНЫЕ АДВОКАТЫ\n    ")]) : _vm._e(), _vm._v(" "), (_vm.adv.length > 3) ? _c('adv-carusiel', {
    attrs: {
      "adv": _vm.adv
    }
  }) : _vm._e(), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      ФИЛЬТР АДВОКАТОВ\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "filter-adv"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col acord-wrapper"
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "accordionExample"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_auto', {
    attrs: {
      "label": "Опишите свою проблему",
      "items": _vm.specializations
    },
    model: {
      value: (_vm.special),
      callback: function($$v) {
        _vm.special = $$v
      },
      expression: "special"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_auto', {
    attrs: {
      "label": " Укажите регион в котором у вас возникла проблема",
      "items": _vm.region
    },
    model: {
      value: (_vm.regions),
      callback: function($$v) {
        _vm.regions = $$v
      },
      expression: "regions"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row button-row"
  }, [_c('ui_btn', {
    on: {
      "click": _vm.toSearchTwoParametrs
    }
  }, [_vm._v("Подобрать")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 small-wrapper"
  }, [_c('ui_title', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._v("ВЫ АДВОКАТ?")]), _vm._v(" "), _c('ui_text', [_vm._v("\n            Зарегистрируйтесь\n            на нашем портале всего\n            за 10 минут и начните получать обращения от клиентов уже сегодня\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "button-row-small-col"
  }, [_c('ui_btn', {
    attrs: {
      "type": "main-btn full-width"
    },
    on: {
      "click": _vm.reg
    }
  }, [_vm._v("Зарегистрироваться")])], 1)], 1)])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      ПОЛЕЗНЫЕ СТАТЬИ\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row arcticl-news-row"
  }, [_c('div', {
    staticClass: "col-md-8 jt-c"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 mobile-padd jt-c"
  }, [_c('img', {
    staticClass: "big-img",
    attrs: {
      "src": _vm.article[_vm.nowArticle].img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 mobile-padd col-left-text"
  }, [_c('ui_sub_title_text', [_vm._v("\n              " + _vm._s(_vm.article[_vm.nowArticle].title) + "\n            ")]), _vm._v(" "), _c('p', [_c('ui_text', {
    attrs: {
      "color": "#9D9D9D"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.article[_vm.nowArticle].text) + "\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "button-row"
  }, [_c('ui_text_href', {
    attrs: {
      "color": "#000000",
      "href": _vm.article[_vm.nowArticle].href
    }
  }, [_vm._v("\n                Подробнее\n              ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row is-mobile control-button"
  }, [_c('img', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": "/static/img/left-banner.png"
    },
    on: {
      "click": function($event) {
        return _vm.changeArticleMobile(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-control"
  }, [_vm._v("Следующие статьи")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": "/static/img/right-banner.png"
    },
    on: {
      "click": function($event) {
        return _vm.changeArticleMobile(1)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col is-desctop jt-c main-article__list"
  }, [_vm._l((_vm.article), function(item, index) {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.isHide),
        expression: "!item.isHide"
      }],
      key: index,
      staticClass: "row select-arcticl",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.changeArticle(index)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": "/static/img/adv-left.svg"
      }
    }), _vm._v(" "), _c('ui_text', [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")])], 1)]
  })], 2)]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      ОТВЕТЫ НА РАСПРОСТРАНЕННЫЕ ВОПРОСЫ\n    ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "filter-adv"
  }, [_c('div', {
    staticClass: "acord-wrapper"
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "accordionExample"
    }
  }, _vm._l((_vm.questions), function(item) {
    return _c('div', {
      key: item.id + '-card',
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header",
      attrs: {
        "id": "accordionHead1"
      }
    }, [_c('h2', {
      staticClass: "mb-0"
    }, [_c('button', {
      staticClass: "btn btn-link text-left button-flex accordion-btn",
      attrs: {
        "type": "button",
        "data-toggle": "collapse",
        "data-target": '#accordionCollapse' + item.id,
        "aria-expanded": "true",
        "aria-controls": 'accordionCollapse' + item.id
      }
    }, [_c('ui_text', {
      staticClass: "text-accord-overwflow"
    }, [_vm._v("\n                        " + _vm._s(item.title) + "\n                      ")]), _vm._v(" "), _c('img', {
      attrs: {
        "src": "/static/img/Accord-controll.svg"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'accordionCollapse' + item.id,
        "aria-labelledby": 'accordionHead' + item.id,
        "data-parent": "#accordionExample"
      }
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('ui_text', [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])], 1)])])
  }), 0)])])]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      КОНТАКТНАЯ ИНФОРМАЦИЯ\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-contact-information container"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-5 mobile-padd"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    attrs: {
      "for": "emailInput"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.support.email),
      expression: "support.email"
    }],
    staticClass: "form-control gray-input",
    attrs: {
      "type": "email",
      "id": "emailInput",
      "placeholder": "Почта"
    },
    domProps: {
      "value": (_vm.support.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.support, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    attrs: {
      "for": "nameInput"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.support.name),
      expression: "support.name"
    }],
    staticClass: "form-control gray-input",
    attrs: {
      "type": "text",
      "id": "nameInput",
      "placeholder": "Имя"
    },
    domProps: {
      "value": (_vm.support.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.support, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    attrs: {
      "for": "textareaInput"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.support.text),
      expression: "support.text"
    }],
    staticClass: "form-control gray-textarea",
    attrs: {
      "id": "textareaInput",
      "placeholder": "Введите сообщение..."
    },
    domProps: {
      "value": (_vm.support.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.support, "text", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-text row",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('ui_btn', {
    attrs: {
      "type": "gray-btn full-width"
    },
    on: {
      "click": _vm.sendSupport
    }
  }, [_vm._v("Оставить заявку")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 text-wraper-home contact-last"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-1"
  }, [_c('ui_text', {
    attrs: {
      "size": "18px"
    }
  }, [_vm._v("\n              Уникальный сервис по поиску адвокатских услуг\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-1"
  }, [_c('img', {
    staticClass: "margin-right-1",
    attrs: {
      "src": "/static/img/icon_phone.svg"
    }
  }), _vm._v(" "), _c('ui_text', {
    attrs: {
      "size": "18px"
    }
  }, [_c('a', {
    attrs: {
      "href": "tel:+74956425292"
    }
  }, [_vm._v("+7 (495) 64 25 292")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-1"
  }, [_c('img', {
    staticClass: "margin-right-1",
    attrs: {
      "src": "/static/img/icon_mail_light.svg"
    }
  }), _vm._v(" "), _c('ui_text', {
    attrs: {
      "size": "18px"
    }
  }, [_c('a', {
    attrs: {
      "href": "mailto: info@mobileadvokat.ru"
    }
  }, [_vm._v("info@mobileadvokat.ru")])])], 1), _vm._v(" "), _vm._m(6)])])])], 1), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 mobile-no-padding"
  }, [_c('img', {
    staticClass: "hummer-img",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/img/hummer.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-only"
  }, [_c('img', {
    staticClass: "is-desctop",
    attrs: {
      "src": "/static/img/bezopas.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "is-mobile",
    attrs: {
      "src": "/static/img/mobile-bezopas.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingOne"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-block btn-link text-left button-h2-text",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "row text-title"
  }, [_vm._v("\n                      По специализации\n                      "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingTwo"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-link btn-block text-left collapsed button-h2-text",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "false",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "row text-title"
  }, [_vm._v("\n                      Регион оказания услуг\n                      "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "youtube-row"
  }, [_c('iframe', {
    attrs: {
      "width": "1280",
      "height": "720",
      "src": "https://www.youtube.com/embed/BaeNwMYJmPI",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "logo-full",
    attrs: {
      "src": "/static/img/logo_full.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row margin-top-1"
  }, [_c('a', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "href": "https://wa.me/79910830833"
    }
  }, [_c('img', {
    staticClass: "margin-right-1",
    staticStyle: {
      "width": "36px"
    },
    attrs: {
      "src": "/static/img/icon_whatsapp_black.svg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://vk.com/mob_advokat"
    }
  }, [_c('img', {
    staticClass: "margin-right-1",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": "/static/img/vk-02-01.svg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCOyKsErmFTcl23B2ckPA0MQ"
    }
  }, [_c('img', {
    staticClass: "margin-right-1",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": "/static/img/you-02-01.svg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16ead974","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home/index.vue
// module id = 341
// module chunks = 2